import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { transition1 } from '../transitions';
import Loading from '../components/Loading';
import { useNavigate } from 'react-router-dom';

import photo1 from '../img/projects/mgop/vid1.MP4';
import photo2 from '../img/projects/mgop/vid2.MP4';
import photo3 from '../img/projects/mgop/vid3.mov';

const Works = () => {
  const allWorks = [
    { src: photo1, tags: ["WeCollective", "Vertical"] },
    { src: photo2, tags: ["WeCollective", "Vertical"] },
    { src: photo3, tags: ["WeCollective", "Vertical"] },
  ];
  
  const navigate = useNavigate()

  const [works] = useState(allWorks);

  if (!works || works.length === 0) return <h1 className='h1'><Loading /></h1>;

  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='pt-32 lg:pt-32 pb-16 px-4 lg:h-screen overflow-auto mb-44 lg:mb-0'
    >
        
      <div className='max-w-7xl mx-auto'>
        <div
        onClick={() => navigate("/album")}
            className=" border-2 mb-10 lg:mb-8 text-center border-black hover:scale-110 hover:bg-zinc-900 hover:text-white w-fit p-4 hover:cursor-pointer"
            >
         Back to Gallery
        </div>
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'>
          {works.map((work, index) => (
            <div key={index} className='w-full overflow-hidden rounded-lg shadow-md'>
              <video
                controls
                className='w-full h-auto object-cover rounded-md hover:scale-105 transition-transform duration-500'
              >
                <source src={work.src} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default Works;
